import script from "./AccountSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountSummary.vue?vue&type=script&setup=true&lang=js"

import "./AccountSummary.vue?vue&type=style&index=0&id=2fbfce14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fbfce14"]])

export default __exports__